'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'church';
var width = 512;
var height = 512;
var aliases = [9962];
var unicode = 'f51d';
var svgPathData = 'M256-32c8.8 0 16 7.2 16 16l0 32 40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0 0 55 121 74c14.3 8.7 23 24.2 23 41l0 28.2 65 32.5c19 9.5 31 28.9 31 50.1L512 456c0 30.9-25.1 56-56 56L56 512c-30.9 0-56-25.1-56-56L0 328.7c0-21.2 12-40.6 31-50.1l65-32.5 0-28.2c0-16.7 8.7-32.2 23-41l121-74 0-55-40 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l40 0 0-32c0-8.8 7.2-16 16-16zM416 480l40 0c13.3 0 24-10.7 24-24l0-127.3c0-9.1-5.1-17.4-13.3-21.5L416 281.9 416 480zm-32 0l0-262.1c0-5.6-2.9-10.7-7.7-13.7L256 130.8 135.7 204.3c-4.8 2.9-7.7 8.1-7.7 13.7l0 262.1 64 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 64 0zM45.3 307.3C37.1 311.3 32 319.6 32 328.7L32 456c0 13.3 10.7 24 24 24l40 0 0-198.1-50.7 25.4zM288 480l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96 64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChurch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;